const filtersTypes = {
    CHANGE_FILTERS: "CHANGE_FILTERS",
}

export default filtersTypes;
